import React, { useCallback, useState, useEffect } from 'react';
import { useNavigation } from '../../../../../shared/utils/useNavigation';
import { copyTextToClipboard } from '../../../../../shared/utils/function';
import { reportError } from '../../../../../shared/sentry';

const TaxBanditsSignatureRequiredCard = ({ 
  pendingSigningUrl, 
  isUsUser = false
}) => {
  const navigate = useNavigation();
  const [hasCopiedSigningUrl, setHasCopiedSigningUrl] = useState(false);

  const handleOpenSigningUrl = useCallback(() => {
    if (!pendingSigningUrl) return;
    navigate.toWebView(pendingSigningUrl, isUsUser ? 'W-9 Tax Sign Form' : 'W-8 Tax Sign Form');
  }, [navigate, pendingSigningUrl]);

  const handleCopySigningUrl = useCallback(async () => {
    if (!pendingSigningUrl) return;
    try {
      const didCopy = await copyTextToClipboard(pendingSigningUrl, 'Copy this signing link:');
      if (didCopy) {
        setHasCopiedSigningUrl(true);
        window.setTimeout(() => setHasCopiedSigningUrl(false), 2000);
      }
    } catch (error) {
      reportError(error, 'TaxBandits copy signing url');
    }
  }, [pendingSigningUrl]);

  useEffect(() => {
    setHasCopiedSigningUrl(false);
  }, [pendingSigningUrl]);

  if (!pendingSigningUrl) {
    return null;
  }

  return (
    <div className="notice_card taxinfo_signature_notice mb-4" role="alert" aria-live="polite">
      <div className="taxinfo_signature_notice__icon bg_icon_g color_yellow" aria-hidden="true">
        <i className="fa-solid fa-file-signature" />
      </div>

      <div className="taxinfo_signature_notice__content w-full">
        <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap">
          <div className="taxinfo_signature_notice__text">
            <h4 className="mb-1">Signature Required</h4>
            <p className="taxinfo_signature_notice__desc mb-0">
              Please e-sign your {isUsUser ? 'W-9' : 'W-8'}
              {' '}form to complete your submission. 
              {' '}You will not be able to request a payout until this is done.
            </p>
          </div>
        </div>

        <div className="taxinfo_signature_notice__actions d-flex flex-row gap-2 mt-3">
          <button
            type="button"
            className="btn btn_primary rounded_8"
            onClick={handleOpenSigningUrl}
          >
            Sign Form
          </button>
          <button
            type="button"
            className="btn btn_dark_outline rounded_8 taxinfo_signature_notice__copy_btn"
            onClick={handleCopySigningUrl}
            aria-label="Copy signing link"
          >
            {hasCopiedSigningUrl ? 'Copied' : 'Copy'}
          </button>
        </div>

        <small className="taxinfo_signature_notice__hint d-block mt-2 text-gray">
          If the form does not open, click "Copy" and paste the link into your browser.
        </small>
      </div>
    </div>
  );
};

export default TaxBanditsSignatureRequiredCard;
